import { PlayerHomeActions } from 'src/redux/player-home';
import { Custom_RequestMethod } from 'src/providers/common-service';
import { RemoteRequest, ContentType } from 'src/remote-request';
import { RemoteHttpService } from 'src/remote-http';
import { HttpResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import * as globals from './globals';
import { Injectable } from '@angular/core';
import { VolatileStorage } from './storage/volatile-storage';
import { Preference } from './storage/preference';
import { AuthenticationResult, SessionInfo } from './data/authentication-info';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
// import * as Rx from 'rxjs';/
import { map, catchError } from 'rxjs/operators';
import { isPresent } from './providers/common-service';
import { AppCustomizerService } from 'src/providers/app-customizer-service/app-customizer.service';
import { SessionActions } from './redux/session';
import { CustomizedAttributes } from './data/mygolf.data';
/**
 * Created by Ashok on 06-04-2016.
 */
@Injectable()
export class AuthenticationService {
  public static CurrentUser: string = 'CurrentUser';
  private curUser: any;

  constructor(
    private http: HttpClient,
    private httpService: RemoteHttpService,
    private preference: Preference,
    private volatileStorage: VolatileStorage,
    public requestMethod: Custom_RequestMethod
    // private customizerService: AppCustomizerService
    // private sessionActions: SessionActions,
    // private playerHomeActions: PlayerHomeActions
  ) {
    preference.getPref(AuthenticationService.CurrentUser).subscribe((data: any) => {
      this.curUser = data;
    });
  }

  /**
   * Checks whether currently signed in or not
   * @returns {boolean} Returns true if signed in and session info exist
   */
  isSignedIn(): boolean {
    const session: SessionInfo = this.volatileStorage.getObject('session');
    return isPresent(session) && isPresent(session.authToken);
  }

  currentUser(): Observable<any> {
    return this.preference.getPref(AuthenticationService.CurrentUser);
  }

  /**
   * Gets the current user from the storage. The current user is one who logged in
   * last
   * @param subscriber The retrieval of current user is asynchronous process.
   * Pass the
   */
  getCurrentUser(): any {
    return this.curUser;
  }

  /**
   * Gets the current session information for the logged in user
   * @returns {SessionInfo} The session info object
   */
  // currentSession(): SessionInfo {
  //     return this.volatileStorage.getObject("session");
  // }

  authenticatePlayer(username: string, password: string): Observable<SessionInfo> {
    const creds = 'email=' + username + '&' + 'password=' + password + '&username=' + username;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    // this.http.get('https://example.com/api/items').pipe(map(data => {})).subscribe(result => {

    // })

    return this.http
      .post(globals.ServerUrls.authentication, creds, {
        headers,
      })
      .pipe(
        map((res: any) => {
          const data: AuthenticationResult = res.json();
          const sessionInfo: SessionInfo = {
            authToken: data.authToken,
            userId: data.user.userId,
            userName: username,
            password,
            userType: data.user.userType,
            playerId: data.user.playerId,
            clubId: data.user.clubId,
            organizerId: data.user.organizerId,
            name: data.name,
            admin: data.user.admin,
          };
          this.volatileStorage.setObject('session', sessionInfo);
          this.volatileStorage.setBoolean('authenticated', true);
          // //Store the current user in preference so that it can be
          // //used for auto login next time
          const curUser = {
            username,
            password,
          };
          this.preference.setPref(AuthenticationService.CurrentUser, curUser);
          this.curUser = curUser;
          //Call the subscriber
          return sessionInfo;
        })
      );
  }

  authenticate(
    userName: string,
    password: string,
    appType?: string,
    customParams?: any
  ): Observable<AuthenticationResult> {
    let creds = 'email=' + userName + '&' + 'password=' + password + '&username=' + userName;
    const _clubId = customParams?.clubId || globals.clubId;
    let _params = {};
    let _validateClubMember = true;
    if (globals.membersOnly) {
      _validateClubMember = true;
    }
    console.debug('custom params : ', customParams);
    if (customParams?.loginMembersOnly !== undefined) {
      console.debug('custom params : ', customParams);
      _validateClubMember = customParams?.loginMembersOnly;
    }
    if (this.bypassLogin.value) {
      _validateClubMember = false;
    }
    let _url: string;
    _url = globals.ServerUrls.newAuthentication;
    const _hdrs = {};
    if (globals.appType === 'club' && globals.clubId && appType === 'play') {
      creds += '&clubId=' + _clubId + '&validateClubMember=' + _validateClubMember;
      // creds = "clubId=" + _clubId + "&validateClubMember=" + _validateClubMember + "&" + creds;
      _url = globals.ServerUrls.newAuthentication;
      _params = {
        email: userName,
        password,
        username: userName,
        clubId: _clubId,
        validateClubMember: _validateClubMember,
      };
      _hdrs['Accept'] = 'application/json';
    } else if (appType === 'club') {
      _url = globals.ServerUrls.newAuthentication;
      _params = {
        email: userName,
        password,
        username: userName,
        // clubId: _clubId,
        // validateClubMember: _validateClubMember
      };
      _hdrs['Accept'] = 'application/json';
    } else {
      // _url = globals.ServerUrls.authentication;
      _url = globals.ServerUrls.newAuthentication;
      _params = {
        email: userName,
        password,
        username: userName,
      };
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    // globals.ServerUrls.authentication
    // return this.http.post(_url, creds, {
    //     headers: headers
    // }).pipe(map((res: any) => {
    //     let data: AuthenticationResult = res;
    //     return data;
    // }));

    const request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params,
      _hdrs
    );
    // return this.httpService
    //   .execute(request)
    //   .pipe(
    //     map((data: any) => {
    //       // let clubInfo: ClubInfo = resp;
    //       // if (!isPresent(clubInfo.clubImage)) clubInfo.clubImage = 'document/img/default_club.png';
    //       // JsonService.deriveFullUrl(clubInfo, 'clubImage');
    //       return data;
    //     })
    //   )
    //   .pipe(catchError(this.http.handleError));

    return this.httpService
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('authenticating resp : ', resp);
          const data: AuthenticationResult = resp;
          this.resetBypassLogin();
          return data;
        })
      )
      .pipe(catchError(this.httpService.handleError));
  }

  public setCurrenUser(email: string) {
    this.signout();
    const curUser = {
      username: email,
    };
    this.curUser = curUser;
    this.preference.setPref(AuthenticationService.CurrentUser, curUser);
  }

  /**
   * Signout the session. This will clear session and clears the current user password
   */
  public signout() {
    // this.customizerService.setRosterDetails(null);
    // this.customizerService.setSeasonDetails(null);
    // this.customizerService.cleanupSubscriptions();
    // this.sessionActions.clearAllStates();
    // this.playerHomeActions.clearAllStates();

    this.volatileStorage.remove('session');
    this.volatileStorage.remove('authenticated');

    // this.preference.clearUserPreference("CompetitionFilter")
    this.preference.setPref('ScorecardSearchFilter');
    this.preference.setPref('ScorecardSearchScorecardType');
    this.preference.setPref('CompetitionFilter');

    // this.pref.setPref("ScorecardSearchFilter");
    // this.pref.setPref("ScorecardSearchScorecardType");
    this.preference.clearUserPreference('ScorecardSearchFilter');
    this.preference.clearUserPreference('ScorecardSearchScorecardType');
    this.preference.clearUserPreference('CompetitionFilter');

    this.preference.getPref(AuthenticationService.CurrentUser).subscribe((curUser: any) => {
      if (curUser?.password) {
        curUser.password = '';
      }
      this.curUser = curUser;
      this.preference.setPref(AuthenticationService.CurrentUser, curUser);
    });
  }

  private handleError(error) {
    let result: any;
    if (error && error.json) {
      result = error.json();
    } else if (error) {
      result = error;
    } else {
      result = 'Server error occured';
    }
    return throwError(result);
  }

  bypassLogin: BehaviorSubject<boolean> = new BehaviorSubject(false);
  setBypassLogin(setValue) {
    this.bypassLogin.next(setValue);
  }
  resetBypassLogin() {
    this.bypassLogin.next(false);
  }
}
